(function (scope) {
  'use strict';

  // Legacy editor dates are wall-clock dates in the configured shop time zone.
  // ISO dates with an explicit offset retain that offset, independent of the visitor.
  function parseDate(value, zone) {
    const match = String(value || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-]\d{2}:\d{2})?$/);
    if (!match) return NaN;
    const [, y, mo, d, h, mi, s = '00', offset] = match;
    const parts = [y, mo, d, h, mi, s].map(Number);
    const utc = Date.UTC(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5]);
    const check = new Date(utc);
    if (check.getUTCFullYear() !== parts[0] || check.getUTCMonth() + 1 !== parts[1] || check.getUTCDate() !== parts[2] || parts[3] > 23 || parts[4] > 59 || parts[5] > 59) return NaN;
    if (offset) return Date.parse(`${y}-${mo}-${d}T${h}:${mi}:${s}${offset}`);
    try {
      const formatter = new Intl.DateTimeFormat('en-GB', { timeZone: zone || 'Europe/Warsaw', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
      const wallTime = timestamp => {
        const p = Object.fromEntries(formatter.formatToParts(timestamp).map(part => [part.type, part.value]));
        return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
      };
      let result = utc;
      for (let i = 0; i < 3; i++) result += utc - wallTime(result);
      return wallTime(result) === utc ? result : NaN;
    } catch (_) { return NaN; }
  }

  function mount(root, clock) {
    clock = clock || scope;
    const configNode = root.querySelector('[data-countdown-config]');
    if (!configNode) return function () {};
    let config;
    try { config = JSON.parse(configNode.textContent); } catch (_) { return function () {}; }
    const target = parseDate(config.date, config.timeZone);
    const timer = root.querySelector('[data-countdown-timer]');
    if (!timer) return function () {};
    let interval = null;
    function stop() {
      if (interval !== null) clock.clearInterval(interval);
      interval = null;
    }
    function setText(selector, text) {
      const node = root.querySelector(selector);
      if (node && text) node.textContent = text;
    }
    if (!Number.isFinite(target)) {
      timer.hidden = true;
      root.dataset.countdownState = 'invalid';
      return stop;
    }
    function update() {
      const distance = Math.max(0, target - clock.Date.now());
      const seconds = Math.floor(distance / 1000);
      const values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
      ['days', 'hours', 'minutes', 'seconds'].forEach((key, index) => setText(`[data-${key}]`, String(values[index]).padStart(2, '0')));
      if (distance > 0) { root.dataset.countdownState = 'running'; return true; }
      root.dataset.countdownState = 'finished';
      setText('[data-countdown-live]', config.liveAfter);
      setText('[data-countdown-title]', config.titleAfter);
      setText('[data-countdown-description]', config.descriptionAfter);
      root.querySelectorAll('.countdown-button').forEach(button => {
        const label = button.querySelector('.pn-button-label');
        if (label && config.buttonTextAfter) label.textContent = config.buttonTextAfter;
        if (config.buttonUrlAfter) button.href = config.buttonUrlAfter;
        button.classList.remove('bg-transparent', 'text-black');
        button.classList.add('bg-black', 'text-white');
        const icon = button.querySelector('svg');
        if (icon) {
          icon.setAttribute('viewBox', '0 0 24 24');
          icon.innerHTML = '<path d="m9 5 7 7-7 7" fill="none" stroke="currentColor" stroke-width="1.5"/>';
        }
      });
      stop();
      return false;
    }
    if (update()) interval = clock.setInterval(update, 1000);
    return stop;
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { parseDate, mount };
  if (scope.customElements && !scope.customElements.get('piano-countdown')) {
    scope.customElements.define('piano-countdown', class extends HTMLElement {
      connectedCallback() { if (this.stopCountdown) this.stopCountdown(); this.stopCountdown = mount(this); }
      disconnectedCallback() { if (this.stopCountdown) this.stopCountdown(); }
    });
  }
})(typeof window !== 'undefined' ? window : globalThis);
